import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import "../styles/Contact.css";

const Contact = () => {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_zrlgp69',        // Replace with your actual EmailJS service ID
        'template_pj6ntpc',       // Replace with your actual EmailJS template ID
        formRef.current,
        'KEwVdZ1KceuZT3AZ_'         // Replace with your actual public key (user ID)
      )
      .then(
        (result) => {
          console.log("Message sent:", result.text);
          alert("Message sent successfully!");
          formRef.current.reset(); // Clear the form
        },
        (error) => {
          console.error("Error sending message:", error.text);
          alert("Something went wrong. Please try again.");
        }
      );
  };

  return (
    <section className="contact">
      <h2>Contact Me</h2>
      
      <div className="contact-content">
        <div className="contact-info">
          <h3>Get In Touch</h3>
          <p>
            <span className="contact-label">Email: </span>
            <span className="contact-value">nikhilsavita186@gmail.com</span>
          </p>
          <p>
            <span className="contact-label">LinkedIn: </span>
            <a
              href="https://www.linkedin.com/in/nikhilsavita186"
              target="_blank"
              rel="noreferrer"
              className="contact-value"
            >
              nikhilsavita186
            </a>
          </p>
          <p>
            <span className="contact-label">GitHub: </span>
            <a
              href="https://github.com/Nikhil181511"
              target="_blank"
              rel="noreferrer"
              className="contact-value"
            >
              Nikhil181511
            </a>
          </p>
        </div>

        <div className="contact-form-container">
          <h3>Send Message</h3>
          <form ref={formRef} onSubmit={sendEmail} className="contact-form">
            <input type="text" name="user_name" placeholder="Your Name" required />
            <input type="email" name="user_email" placeholder="Your Email" required />
            <textarea name="message" placeholder="Your Message" required />
            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
